import api from "../services/api";

// Abrir conversa com um contato, sabendo lidar com o "já está com alguém".
//
// Três telas fazem a mesma coisa (nova conversa, cartão de contato numa
// mensagem e o quadro do Kanban) e as três batiam no mesmo muro: o backend
// recusa com ERR_OTHER_OPEN_TICKET e o atendente via um erro sem saída. Aqui
// a recusa vira informação — de quem é o atendimento — para a tela poder
// oferecer o pedido de transferência.
//
// Devolve `{ ticket }` quando dá para entrar direto (inclusive quando o
// atendimento aberto já é meu) ou `{ emAtendimento }` quando é de outra
// pessoa. Qualquer outro erro sobe: quem chamou é que sabe como avisar.
export const abrirConversaComContato = async ({
	contactId,
	userId,
	whatsappId,
}) => {
	try {
		const { data: ticket } = await api.post("/tickets", {
			contactId,
			userId,
			status: "open",
			whatsappId: whatsappId || undefined,
		});

		return { ticket };
	} catch (err) {
		if (err?.response?.data?.error !== "ERR_OTHER_OPEN_TICKET") throw err;

		const { data } = await api.get(`/transfer-requests/contact/${contactId}`);

		// Já é meu: entrar na conversa é o que a pessoa queria, e perguntar
		// seria burocracia.
		if (data?.meu) return { ticket: { id: data.id } };

		if (data) return { emAtendimento: data };

		throw err;
	}
};

export default abrirConversaComContato;
